module.exports = "<div class=\"container\">\n  <h1 style=\"color:red\">404</h1>\n  <h2>Page not found</h2>\n  <p>Something went wrong....!</p>\n</div>"